import { useContext } from 'react'
import { GroupWorkflowActionsContext } from '../providers/GroupWorkflowActionsProvider'

export default function useGroupWorkflowActions() {
  return useContext(GroupWorkflowActionsContext)
}
